/**
 * Intl lib was included in polyfill.io that was deleted due to malware. This function might not work anymore.
 */
const formatter = (value: number): string =>
  new Intl.NumberFormat('nb-no', {
    maximumFractionDigits: 0,
  }).format(value);

export const formatAmount = (amount = 0): string => {
  return `${formatter(amount)},-`;
};

export const formatRecurringAmount = (amount = 0): string => {
  return `${formatter(amount)},- per mnd.`;
};

export const removeWhiteSpaces = (str: string | undefined): string => {
  return str?.replace(/\s/g, '') || '';
};

export const removeComas = (str: string | undefined): string => {
  return str?.replace(',', '') || '';
};

export const removePhoneCountryCode = (str: string | undefined): string | undefined => {
  return str?.startsWith('47') && str?.length === 10 ? str.substring(2) : str;
};
